const digest = 'bea9e349aeeb7db3e0481ced228b8d014b294b30525baea5af361bb74c9aaeda';
const css = `._loaderContainer_393tj_1{height:675px}@media (1024px <= width){._loaderContainer_393tj_1{height:611px}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'loaderContainer': '_loaderContainer_393tj_1' };
export const loaderContainer = '_loaderContainer_393tj_1';
export { css, digest };